import { render, staticRenderFns } from "./Cheersong.vue?vue&type=template&id=4ddbf5b8"
import script from "./Cheersong.vue?vue&type=script&lang=js"
export * from "./Cheersong.vue?vue&type=script&lang=js"
import style0 from "./Cheersong.vue?vue&type=style&index=0&id=4ddbf5b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports